module.exports = __webpack_public_path__ + "img/IMG_0277.1b264b9c.png";